module.exports = __webpack_public_path__ + "img/41_40.fbc71eca.png";